import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Box, Paper, Typography, Button, MobileStepper } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

import {imagesAbout} from '../../data/aboutImgData';

const images = imagesAbout;

function ModernCarousel() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (index) => {
    setActiveStep(index);
  };

  return (
    <Box sx={{ maxWidth: 400, flexGrow: 1 }}>
      {/* Empty Paper with label area (like original) */}
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 50,
          pl: 2,
          bgcolor: 'background.default',
        }}
      >
        <Typography>{images[activeStep].label}</Typography>
      </Paper>

      {/* Custom Carousel that matches original design */}
      <Box sx={{ position: 'relative' }}>
        <Carousel
          selectedItem={activeStep}
          onChange={handleStepChange}
          autoPlay
          infiniteLoop
          interval={3000}
          showThumbs={false}
          showStatus={false}
          showArrows={false} // We'll use custom buttons below
          showIndicators={false} // We'll use MobileStepper instead
          swipeable={true}
          emulateTouch={true}
          // Hide default controls completely
          renderArrowPrev={() => null}
          renderArrowNext={() => null}
          renderIndicator={() => null}
        >
          {images.map((image, index) => (
            <div key={index}>
              <Box
                component="img"
                src={image.imgPath}
                alt={image.label}
                sx={{
                  height: 390,
                  display: 'block',
                  maxWidth: 400,
                  overflow: 'hidden',
                  width: '100%',
                  objectFit: 'cover',
                }}
              />
            </div>
          ))}
        </Carousel>

        {/* Custom navigation arrows positioned inside carousel */}
        <Button
          size="small"
          onClick={handleBack}
          disabled={activeStep === 0}
          sx={{
            position: 'absolute',
            left: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            minWidth: '40px',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            zIndex: 2,
            '&:hover': {
              backgroundColor: 'white',
            },
          }}
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </Button>

        <Button
          size="small"
          onClick={handleNext}
          disabled={activeStep === maxSteps - 1}
          sx={{
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            minWidth: '40px',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            zIndex: 2,
            '&:hover': {
              backgroundColor: 'white',
            },
          }}
        >
          {theme.direction === 'rtl' ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </Button>
      </Box>

      {/* MobileStepper at bottom (exact same as original) */}
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
            sx={{
              textTransform: 'none',
              fontWeight: 500,
            }}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft sx={{ ml: 0.5 }} />
            ) : (
              <KeyboardArrowRight sx={{ ml: 0.5 }} />
            )}
          </Button>
        }
        backButton={
          <Button
            size="small"
            onClick={handleBack}
            disabled={activeStep === 0}
            sx={{
              textTransform: 'none',
              fontWeight: 500,
            }}
          >
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight sx={{ mr: 0.5 }} />
            ) : (
              <KeyboardArrowLeft sx={{ mr: 0.5 }} />
            )}
            Back
          </Button>
        }
        sx={{
          backgroundColor: 'transparent',
          '& .MuiMobileStepper-dot': {
            backgroundColor: '#e0e0e0',
            width: 8,
            height: 8,
            margin: '0 2px',
          },
          '& .MuiMobileStepper-dotActive': {
            backgroundColor: '#1976d2',
          },
        }}
      />
    </Box>
  );
}

export default ModernCarousel;